<template>
  <scout-form
    :is-modified="!!minimum || !!maximum"
    :label="prefix + '年収'"
    half
  >
    <input
      v-model="internalMinimum"
      :class="{ 'is-invalid-input': isInvalid }"
      class="boss-input"
      style="width: 6em;"
      type="number"
      max="99999"
      min="0"
      data-test="minimum"
      @keypress="onlyNumberInRange($event, 99999)"
    >
    <span>万円</span>
    〜
    <input
      v-model="internalMaximum"
      :class="{ 'is-invalid-input': isInvalid }"
      class="boss-input"
      style="width: 6em;"
      type="number"
      max="99999"
      min="0"
      data-test="maximum"
      @keypress="onlyNumberInRange($event, 99999)"
    >
    <span>万円</span>
    <validation-label
      v-if="isInvalid"
      label="正しい大小関係で範囲を入力してください。"
      data-test="validation"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import eventValidations from '@/lib/eventValidations'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    ScoutForm,
    ValidationLabel
  },
  mixins: [eventValidations],
  props: {
    maximum: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    minimum: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    prefix: {
      default: '',
      type: String
    }
  },
  computed: {
    isInvalid () {
      return !!this.minimum && !!this.maximum && this.minimum > this.maximum
    },
    internalMinimum: {
      get () {
        return this.minimum
      },
      set (value) {
        this.$emit('update:minimum', value ? Number(value) : null)
      }
    },
    internalMaximum: {
      get () {
        return this.maximum
      },
      set (value) {
        this.$emit('update:maximum', value ? Number(value) : null)
      }
    }
  }

}
</script>
